var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectoryListingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7998H4M20 4H4M13.6 20H4M5.2 13.6002H18.8C19.4627 13.6002 20 13.0629 20 12.4002V8.4002C20 7.73745 19.4627 7.2002 18.8 7.2002H5.2C4.53726 7.2002 4 7.73745 4 8.4002V12.4002C4 13.0629 4.53726 13.6002 5.2 13.6002Z",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryListingIcon);
export default __webpack_public_path__ + "static/media/directory-listing-icon.1526d7b3e396a2b39f71b8cd13481371.svg";
export { ForwardRef as ReactComponent };